
export function ageFilter() {
  var calculateAge = function(birthday: Date): number { // birthday is a date
         var ageDifMs = Date.now() - birthday.getTime();
         var ageDate = new Date(ageDifMs); // miliseconds from epoch
         return Math.abs(ageDate.getUTCFullYear() - 1970);
     };

  return function(birthDate: Date) {
    if (!birthDate) { return -1;}
      return calculateAge(birthDate);
  }
}



/** WEBPACK FOOTER **
 ** ./src/scripts/filters/age.ts
 **/